<template>
  <div class="container">
    <div class="tw-grid tw-grid-cols-4 tw-gap-8">
      <TheOverviewPanel class="tw-col-span-4" :publication="publication"/>

      <TheThemePanel v-if="publication.attributes.theme" class="tw-col-span-4" :publication="publication"/>

      <TheListPanel class="tw-col-span-3" :publication="publication"/>

      <div>
        <TheCountdownPanel :publication="publication"/>

        <button type="button" class="btn btn-black btn-block" @click="downloadAds">
          <i class="fa fa-download"></i> Download
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import store from '@/store'
import TheListPanel from "./TheListPanel.vue";
import TheOverviewPanel from "./TheOverviewPanel";
import TheCountdownPanel from "./TheCountdownPanel.vue";
import TheThemePanel from "./TheThemePanel.vue";

export default {
  components: {TheThemePanel, TheCountdownPanel, TheListPanel, TheOverviewPanel},

  model: {
    prop: 'publication',
    event: 'publication-updated'
  },

  props: {
    publication: {
      required: true
    }
  },

  data() {
    return {
      shared: store
    }
  },

  methods: {
    downloadAds() {
      axios.post('/api/v1/reports/content-list', {publication_id: this.publication.id}, {
        headers: {
          'Authorization': 'Bearer ' + this.shared.token
        },
        responseType: 'blob'
      })
          .then(response => {
            download(response.data, response.headers['content-disposition'].slice(22, -1))
          })
    }
  }
}
</script>
